export default {"src":"/_next/static/media/ic-sentiment-1.6542286e.svg","height":29,"width":28,"blurWidth":0,"blurHeight":0};